export class IndustryProductDiscounts {
  constructor(
    private industryProductDiscountKey: IndustryProductDiscountKey,
    private ean: IndustryProductEan,
    private userDiscount: number,
    private directDiscount: number,
    private indirectDiscount: number,
  ) {}

  public getIndustryProductDiscountKey(): IndustryProductDiscountKey {
    return this.industryProductDiscountKey;
  }

  public getEan(): IndustryProductEan {
    return this.ean;
  }

  public getUserDiscount(): number {
    return this.userDiscount;
  }

  public getDirectDiscount(): number {
    return this.directDiscount;
  }

  public getIndirectDiscount(): number {
    return this.indirectDiscount;
  }

  public setIndustryProductDiscountKey(value: IndustryProductDiscountKey) {
    this.industryProductDiscountKey = value;
  }

  public setEan(value: IndustryProductEan) {
    this.ean = value;
  }

  public setUserDiscount(value: number) {
    this.userDiscount = value;
  }

  public setDirectDiscount(value: number) {
    this.directDiscount = value;
  }

  public setIndirectDiscount(value: number) {
    this.indirectDiscount = value;
  }
}

export class IndustryProductDiscountKey {
  constructor(private value: string) {}

  public getValue(): string {
    return this.value;
  }
  public setValue(value: string) {
    this.value = value;
  }
}

export class IndustryProductEan {
  constructor(private value: string) {}

  public getValue(): string {
    return this.value;
  }
  public setValue(value: string) {
    this.value = value;
  }
}
